<script setup lang="ts">
import { ref } from 'vue';
import { getCurrentLocale } from '@/i18n';
import { useI18n } from 'vue-i18n';
import capitalize from 'lodash/capitalize';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import { useTourManagementStore } from '@/store/TourManagementStore';
import { useGroupTypeStore } from '@/store/GroupTypeStore';
import { guideList, tourTypeList } from '@/constants/tour';
import Button from 'primevue/button';
import { useDialog } from 'primevue/usedialog';
import AddManualTourModal from '@/components/modal/AddManualTourModal.vue';
import TourDetailsList from '@/components/tour/TourDetailsList.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

const dialog = useDialog();
const { t } = useI18n({ useScope: 'global' });
const currentLanguage = getCurrentLocale();
const langCapitalize = capitalize(currentLanguage);
const tourManagementStore = useTourManagementStore();
const groupTypeManagement = useGroupTypeStore();
const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;

const groupTypeList = ref([]);
const tourDetailsData = ref<any>([]);
const isLoading = ref(false);

const openAddTourModal = () => {
  const dialogRef = dialog.open(AddManualTourModal, {
    props: {
      header: t('management.tour.add_manual'),
      modal: true,
      style: {
        width: '85vw'
      }
    },
    data: {
      isEdit: false
    },
    emits: {
      onApply: () => {
        getListTourDetail();
        dialogRef.close();
      },
      onClose: () => {
        dialogRef.close();
      }
    }
  });
};

const getGroupTypeData = () => {
  groupTypeManagement
    .getGroupTypeList()
    .then((response) => {
      groupTypeList.value = response.data;
    })
    .finally(() => {});
};
getGroupTypeData();

const getListExistGroupType = (data: any, groupTypes: any) => {
  return data?.filter((group: any) => groupTypes?.map((groupType: any) => groupType.sk).includes(group));
};

const handleReplaceValueToName = (value: string, field: string) => {
  if (field === 'tourType') {
    return tourTypeList.find((tourType: any) => tourType.value === value)?.[`name${langCapitalize}`];
  }
  return guideList.find((guide: any) => guide.value === value)?.[`name${langCapitalize}`];
};

const getListTourDetail = () => {
  isLoading.value = true;
  tourManagementStore
    .getListManagementTour()
    .then((res) => {
      if (res?.data) {
        tourDetailsData.value = res.data;
      }
      tourDetailsData.value = tourDetailsData.value?.map((tour: any) => {
        tour.groupTypes = getListExistGroupType(tour.groupTypes, groupTypeList.value);
        tour.tourType = handleReplaceValueToName(tour.tourType, 'tourType');
        tour.guided = handleReplaceValueToName(tour.guided, 'guided');
        return tour;
      });
    })
    .finally(() => {
      isLoading.value = false;
    });
};

getListTourDetail();

defineExpose({
  getListTourDetail
});
</script>
<template>
  <LoadingSpinner v-if="isLoading" />
  <div class="tour-detail mb-3 text-right">
    <Button v-if="authorizations.tour_detail_configuration.add_tour_detail_manually" data-testid="btn_add_tour" icon="pi pi-plus" :label="$t('management.tour.add_tour_detail')" @click="openAddTourModal()"></Button>
  </div>
  <TourDetailsList :tourDetailsData="tourDetailsData" :groupTypeList="groupTypeList" @initTableData="getListTourDetail()"></TourDetailsList>
</template>
